import { render, staticRenderFns } from "./solution_detail.vue?vue&type=template&id=5825f3b3&scoped=true"
import script from "./solution_detail.vue?vue&type=script&lang=js"
export * from "./solution_detail.vue?vue&type=script&lang=js"
import style0 from "./solution_detail.vue?vue&type=style&index=0&id=5825f3b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825f3b3",
  null
  
)

export default component.exports